import { render, staticRenderFns } from "./newsFeed.vue?vue&type=template&id=410faecb&scoped=true"
import script from "./newsFeed.vue?vue&type=script&lang=js"
export * from "./newsFeed.vue?vue&type=script&lang=js"
import style0 from "./newsFeed.vue?vue&type=style&index=0&id=410faecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410faecb",
  null
  
)

export default component.exports